
import Navbar from "../components/landingPage/Navbar";

const steps = [
  { n: 1, title: "Register" },
  { n: 2, title: "Submit Your Idea" },
  { n: 3, title: "Upload CAD / Design" },
  { n: 4, title: "Select Facility & Machine" },
  { n: 5, title: "Get Quotation" },
  { n: 6, title: "Approve & Pay" },
  { n: 7, title: "Track Production" },
  { n: 8, title: "Receive Prototype" },
];

export default function HowItWorks() {
  return (
    <>
    <Navbar />
    <section className="bg-gray-50 py-20" id="how-it-works">
      <div className="max-w-7xl mx-auto px-6">
        <span className="inline-block text-xs font-semibold bg-white border border-gray-200 rounded-full px-4 py-1.5 mb-5">
          Journey
        </span>
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-3">
          How ProtoHub works
        </h2>
        <p className="text-gray-600 mb-12">
          Eight steps from idea to delivered prototype.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map(({ n, title }) => (
            <div key={n} className="bg-white rounded-2xl p-6 shadow-sm">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-9 h-9 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 text-white font-bold flex items-center justify-center">
                  {n}
                </span>
                <span className="text-xs font-semibold text-gray-400">
                  STEP {n}
                </span>
              </div>
              <h3 className="font-bold text-gray-900 text-lg">{title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
    </>
  );
}